/* Bull Kicks — PDP US Men's <-> US Women's size relabel.
   Cosmetic only: rewrites each size pill's visible LABEL text (men +1.5 = women).
   The radio <input value> is never touched, so variant selection / add-to-cart
   stay 100% correct. */
(function () {
  'use strict';
  function fmtSize(n) { return String(Math.round(n * 2) / 2); }
  function sizeTextNode(label) {
    for (var i = 0; i < label.childNodes.length; i++) {
      var n = label.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) return n;
    }
    return null;
  }
  function init() {
    var toggle = document.querySelector('[data-bk-size-toggle]');
    var pills = document.querySelector('[data-bk-size-pills]');
    if (!toggle || !pills) return;
    var labels = pills.querySelectorAll('label');
    var legend = pills.querySelector('legend');
    var legendMen = legend ? legend.textContent.trim() : '';
    var btns = toggle.querySelectorAll('[data-bk-gender]');
    function apply(g) {
      labels.forEach(function (lb) {
        var node = sizeTextNode(lb);
        if (!node) return;
        if (!lb.getAttribute('data-men')) lb.setAttribute('data-men', node.textContent.trim());
        var men = parseFloat(lb.getAttribute('data-men'));
        if (isNaN(men)) return;
        node.textContent = (g === 'women') ? fmtSize(men + 1.5) : lb.getAttribute('data-men');
      });
      if (legend && legendMen) {
        // i18n: tokens injected by product-variant-picker.liquid; Chinese fallback.
        var vp = (window.BK_I18N && window.BK_I18N.variant_picker) || {};
        legend.textContent = (g === 'women') ? legendMen.replace(vp.men_token || '男碼', vp.women_token || '女碼') : legendMen;
      }
      btns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-bk-gender') === g); });
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { apply(b.getAttribute('data-bk-gender')); }); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
